// Global Instructions Rule Applied!
// Read shape of ONE resolved candidate row from view__bulk_prospect_candidates
// (Bulk Add Prospects screen), strict twin of the backend zon model
// (bulk_prospect_candidates_model.py). lp_status_* are nullish (the cfg
// default rule can be missing); prog__existing_stage_label only carries a
// value for accounts already pipeline-placed in the target fund.
import { z } from 'zod'

export const BulkProspectCandidateSchema = z
  .object({
    // Plain z.string() for ids — legacy CRM uuids (Dataverse-style version
    // nibbles) fail Zod's strict RFC-4122 .uuid() check; same idiom as
    // distribution_list_recipients_model.ts.
    accounts__id: z.string(),
    accounts__name: z.string().nullish(),
    lp_status_id: z.string().nullish(),
    lp_status_label: z.string().nullish(),
    prog__has_live_prospect_in_target: z.boolean(),
    prog__existing_stage_label: z.string().nullish()
  })
  .strict()

export type BulkProspectCandidate = z.infer<typeof BulkProspectCandidateSchema>

export const validateBulkProspectCandidate = (data: unknown): BulkProspectCandidate =>
  BulkProspectCandidateSchema.parse(data)

// ── Request/response shapes ─────────────────────────────────────────────────

export interface BulkProspectResolvePayload {
  target_fund_id: string
  fund_ids: string[]
  lp_status_ids: string[]
}

export interface BulkProspectResolveResponse {
  data: BulkProspectCandidate[]
  error?: string
}

export interface BulkProspectCreateRow {
  investor_id: string
  stage_id: string
  commitment?: number
  allow_duplicate?: boolean
}

export interface BulkProspectCreatePayload {
  target_fund_id: string
  rows: BulkProspectCreateRow[]
}

export interface BulkProspectCreateResponse {
  data: { created_count: number; prospect_ids: string[] } | null
  /** HTTP 409 — accounts that gained a live prospect between resolve and submit. */
  conflictAccountIds?: string[]
  error?: string
}
